









































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  GetDeptData,
  GetUserDetail,
  PostAddUser,
  GetRoleData,
  GetDictionary,
  PatchEditUser,
} from "@/request/common";
import { BuildTree } from "@/utils/base";
@Component({})
export default class Name extends Vue {
  private id: any = "";
  private institutions: any = [];
  private jueseOpt: any = [];
  private user: any = {
    role_info: [],
    is_active: true,
  };

  private account: any = {};
  private accounts: any = {};
  private ifShowAccountSearch: boolean = false;
  private searchAccountText: any = "";
  private xiangguanzhanghus: any[] = [];
  private centers: any[] = [];
  private roles: any = [];
  private genders: any = [];
  private forceUpdate() {
    this.$forceUpdate();
  }
  private getGenderOption() {
    const params: any = {
      params: {
        dictionary_key: "性别",
      },
    };
    GetDictionary(this, params).then((res: any) => {
      this.genders = res.data;
    });
  }
  private levelChange(e: any) {
    this.getRoleInInstitution(e);
  }
  /**
   * @description 获取医生账户详情
   */
  private getDetail() {
    // 获取用户信息
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetUserDetail(this, this.id, loading)
      .then((res: any) => {
        loading.close();
        this.user = res.data;
      })
      .catch(() => {
        loading.close();
      });
  }
  /**
   * @description 获得机构和角色的关系
   */
  private getRoleInInstitution(id: any) {
    if (!id) {
      return;
    }
    if (this.institutions.length > 0) {
      // 寻找level
      let result: any = {};
      this.institutions.forEach((items: any) => {
        if (id === items.institution_id) {
          result = items;
        } else {
          items.sub_institutions.forEach((item: any) => {
            if (id === item.institution_id) {
              result = item;
            } else {
              if (item.sub_institutions) {
                item.sub_institutions.forEach((ele: any) => {
                  if (id === ele.institution_id) {
                    result = ele;
                  }
                });
              }
            }
          });
        }
      });
      this.user["机构"] = result;
      if (result.level === 1) {
        this.jueseOpt = ["项目负责人"];
      } else if (result.level === 2) {
        this.jueseOpt = ["医院管理员"];
      } else if (result.level === 3) {
        this.jueseOpt = ["高级医生", "普通医生"];
      }
    } else {
      this.getZuzhijiagouList("").then(() => {
        // 寻找level
        let result: any = {};
        this.institutions.forEach((items: any) => {
          if (id === items.institution_id) {
            result = items;
          } else {
            items.sub_institutions.forEach((item: any) => {
              if (id === item.institution_id) {
                result = item;
              } else {
                if (item.sub_institutions) {
                  item.sub_institutions.forEach((ele: any) => {
                    if (id === ele.institution_id) {
                      result = ele;
                    }
                  });
                }
              }
            });
          }
        });
        this.user["机构"] = result;
        if (result.level === 1) {
          this.jueseOpt = ["项目负责人"];
        } else if (result.level === 2) {
          this.jueseOpt = ["医院管理员"];
        } else if (result.level === 3) {
          this.jueseOpt = ["高级医生", "普通医生"];
        }
      });
    }
  }
  /**
   * @description 保存
   */
  private save() {
    if (!this.user.username) {
      this.$message.error("请填写账户名");
      return;
    }
    if (!this.user.name) {
      this.$message.error("请填写姓名");
      return;
    }
    if (!this.id && !this.user.password) {
      this.$message.error("请输入登录密码");
      return;
    }
    if (!this.user.dept) {
      this.$message.error("请选择部门");
      return;
    }
    if (!this.user.role || this.user.role.length == 0) {
      this.$message.error("请选择角色");
      return;
    }
    if (!this.user.gender && this.user.gender !== 0) {
      this.$message.error("请选择性别");
      return;
    }
    // if (!this.user.mobile) {
    //   this.$message.error("请填写手机号");
    //   return;
    // }
    // if (this.user.mobile.length !== 11) {
    //   this.$message.error("手机号长度不正确");
    //   return;
    // }
    // if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.user.mobile)) {
    //   this.$message.error("手机号格式不正确");
    //   return;
    // }
    if (this.user.id) {
      const params: any = {
        username: this.user.username,
        name: this.user.name,
        dept: this.user.dept,
        role: this.user.role,
        gender: this.user.gender,
        mobile: this.user.mobile,
        is_active: this.user.is_active,
      };
      // 编辑
      PatchEditUser(this, this.user.id, this.user).then((data: any) => {
        this.$message.success("保存成功");
        this.$router.back();
      });
    } else {
      // 新增
      PostAddUser(this, this.user).then((data: any) => {
        this.$message.success("保存成功");
        this.$router.back();
      });
    }
  }

  /**
   * @description 获得可选的组织结构列表
   */
  private getZuzhijiagouList(text: any) {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {},
      };
      GetDeptData(this, params)
        .then((data: any) => {
          this.institutions = BuildTree(data.data);
          resolve(data);
        })
        .catch(() => {
          reject();
        });
    });
  }
  private getRoles() {
    GetRoleData(this, {}).then((res: any) => {
      this.roles = res.data;
    });
  }
  private mounted() {
    this.getZuzhijiagouList(" ");
    this.getRoles();
    this.getGenderOption();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
    }
  }
}
